(() => {
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const stops = new Set();
  const mount = root => {
    root.querySelectorAll('.product-card').forEach(card => {
      if (card.dataset.pkHoverReady) return;
      const media = card.querySelector('.product-card__media');
      const img = media?.querySelector('img');
      const data = card.querySelector('[data-pk-hover-photos]');
      if (!img || !data) return;
      let photos;
      try { photos = JSON.parse(data.textContent); } catch { return; }
      if (!Array.isArray(photos) || photos.length < 2) return;
      card.dataset.pkHoverReady = 'true';
      let timer, active = false, index = 0, generation = 0;
      const original = {};
      ['src','srcset','sizes','alt'].forEach(name => { original[name] = img.getAttribute(name); });
      const stop = () => {
        active = false;
        generation++;
        clearTimeout(timer);
        Object.entries(original).forEach(([name,value]) => value === null ? img.removeAttribute(name) : img.setAttribute(name,value));
        media.classList.remove('pk-hover-playing');
        stops.delete(stop);
      };
      const schedule = () => {
        if (!active) return;
        const token = generation;
        index = (index + 1) % photos.length;
        const photo = photos[index];
        const next = new Image();
        next.src = photo.src;
        const ready = next.decode ? next.decode() : new Promise((resolve,reject) => {
          if (next.complete) return next.naturalWidth ? resolve() : reject();
          next.onload = resolve; next.onerror = reject;
        });
        ready.then(() => {
          timer = setTimeout(() => {
            if (!active || generation !== token || reduce.matches || !hover.matches) return;
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = photo.src;
            img.alt = photo.alt || original.alt || '';
            schedule();
          },1100);
        }).catch(() => {
          if (active && generation === token) timer = setTimeout(schedule,1100);
        });
      };
      media.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || !hover.matches || reduce.matches || active) return;
        active = true; generation++; index = 0;
        stops.add(stop);
        media.classList.add('pk-hover-playing');
        schedule();
      });
      media.addEventListener('pointerleave',stop);
      media.addEventListener('pointercancel',stop);
      media.addEventListener('click',stop);
    });
  };
  const stopAll = () => { [...stops].forEach(stop => stop()); };
  reduce.addEventListener('change',stopAll);
  hover.addEventListener('change',stopAll);
  document.addEventListener('visibilitychange',() => { if (document.hidden) stopAll(); });
  window.addEventListener('pagehide',stopAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mount(document),{once:true});
  else mount(document);
  document.addEventListener('shopify:section:load',event => mount(event.target));
})();